import { MatchInterviewType } from '../match';

const TELEPHONIC_INTERVIEW_TRANSLATION = 'Telefonischer Termin';
const DIGITAL_INTERVIEW_TRANSLATION = 'Digitaler Termin';

export const VIRTUAL_INTERVIEW_LOCATIONS_TRANSLATIONS: Record<string, string> = {
  [MatchInterviewType.Telephonic]: TELEPHONIC_INTERVIEW_TRANSLATION,
  [MatchInterviewType.Digital]: DIGITAL_INTERVIEW_TRANSLATION,
  [MatchInterviewType.PostponedTelephonic]: TELEPHONIC_INTERVIEW_TRANSLATION,
  [MatchInterviewType.PostponedDigital]: DIGITAL_INTERVIEW_TRANSLATION,
};
